export const defaultUrl = process.env.PRIMER_ANALYTICS_API_URL as string;
